import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/app/store";

//*Components imports
import { ActivityHeader } from "./components/ActivityModal/ActivityHeader";
import { ActivityList } from "./components/ActivityModal/ActivityList";
import { ActivityDetails } from "./components/ActivityModal/ActivityDetails";
import DadosDosFormularios from "./DadosFormularios";

//*Hooks imports
import { useGetClientProducts } from "@/hooks/clients/querys/useGetClientProducts";
import { useSaveClientProduct } from "@/hooks/clients/mutations/useSaveClientProduct";
import { useGetProcesses } from "@/hooks/processes/querys/useGetProcesses";
import { useGetPhaseForms } from "@/hooks/phaseforms/querys/useGetPhaseForms";

//* Utils imports
import {
  calculateStats as calculateStatsUtil,
  mapActivityData,
} from "./components/ActivityModal/utils";

//* Features imports
import { PhaseFormFieldType } from "@/features/phaseForm";
import { filledFormService } from "@/features/filledForm/filledFormService";
import { fetchTemplates } from "@/features/template/TemplateSlice";
import { fetchTechinicals } from "@/features/techinicaldocument/TechinicalSlice";

export default function AtividadesModal(props: any) {
  const dispatch = useDispatch<AppDispatch>();
  const { items: templates } = useSelector(
    (state: RootState) => state.template,
  );
  const { items: techinicals } = useSelector(
    (state: RootState) => state.techinical,
  );

  const [faseAtiva, setFaseAtiva] = useState<any>({});
  const [client_product, setClientProduct] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [_filledForms, setFilledForms] = useState([]);
  const [phaseForms, setPhaseForms] = useState<any>({});
  const [proccess, setProccess] = useState([]);
  const [docsFilled, setDocsFilled] = useState<any>({});
  const [loadingUploads, setLoadingUpload] = useState<any>({});

  const { getClientProducts } = useGetClientProducts();
  const { saveClientProduct: saveClientProductMutation } =
    useSaveClientProduct();
  const { getProcesses } = useGetProcesses();
  const { getPhaseForms } = useGetPhaseForms();

  const [selectActivity, setActivity] = useState<any>(null);
  const [selectedTab, setSelectedTab] = useState("activities");
  const [bindingQuestion, setBindingQuestion] = useState(null);

  useEffect(() => {
    dispatch(fetchTemplates({}));
    dispatch(fetchTechinicals({}));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      setBindingQuestion(null);
    };
  }, []);

  useEffect(() => {
    proccess.forEach((item3: any) => {
      item3.filledForms?.forEach((item4: any) => {
        item4.data?.forEach((item5: any) => {
          if (item5.field.type == PhaseFormFieldType.BINDING_QUESTION) {
            const bindingValues = Array.isArray(item5?.data)
              ? item5.data
              : item5?.data != null
                ? [item5.data]
                : [];
            bindingValues.forEach((item6: any) => {
              if (item6 == props.selectClient.product._id) {
                setBindingQuestion({
                  processId: item3._id,
                  phaseFormId: item4.phaseFormId,
                });
              }
            });
          }
        });
      });
    });
  }, [proccess]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [clientsProducts, proccessData, forms] = await Promise.all([
        getClientProducts(props.selectClient.client._id),
        getProcesses({
          clientId: props.selectClient.client._id,
          whatsapp: props.selectClient.client.whatsapp,
        }),
        getPhaseForms(),
      ]);

      const { docsFilledMap, phaseFormsIdFilled, filled_forms } =
        mapActivityData(
          forms,
          proccessData,
          props.selectClient.product.phases,
          props.documents,
        );
      console.log("docsfilled", docsFilledMap);
      setProccess(proccessData);
      setPhaseForms(phaseFormsIdFilled);
      setDocsFilled(docsFilledMap);
      setFilledForms(filled_forms);

      setClientProduct(
        clientsProducts.data.find(
          (item: any) => item.productId == props.selectClient.product._id,
        ),
      );
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.selectClient.product && props.selectClient.client) {
      let phase: any = { ...props.selectClient.product.phases[0] };
      phase.index = 0;
      loadData();
      setFaseAtiva(phase);
    }
  }, [props.selectClient.product, props.selectClient.client]);

  const saveClientProduct = (e: any) => {
    saveClientProductMutation(e)
      .then((resp) => {
        if (
          props.selectClient != null &&
          props.selectClient?.client?._id == resp?.data?.client_id
        ) {
          setClientProduct(resp.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleUploadFile = async (docId: string, file: File) => {
    let phaseFormId = "";
    let processId = "";
    let fieldId: any = "docs_" + docId;
    setLoadingUpload((prev: any) => ({ ...prev, [docId]: true }));

    try {
      proccess.forEach((item3: any) => {
        item3.filledForms?.forEach((item4: any) => {
          item4.data?.forEach((item5: any) => {
            if (item5.field.type == PhaseFormFieldType.BINDING_QUESTION) {
              const bindingValues = Array.isArray(item5?.data)
                ? item5.data
                : item5?.data != null
                  ? [item5.data]
                  : [];
              bindingValues.forEach((item6: any) => {
                if (item6 == props.selectClient.product._id) {
                  processId = item3._id;
                  phaseFormId = item4.phaseFormId;
                }
              });
            }
          });
        });
      });

      if (!processId && proccess.length > 0) {
        const p = proccess[0] as any;
        processId = p._id;
        phaseFormId = p.filledForms?.[0]?.phaseFormId || "";
      }

      const { path } = await filledFormService.uploadDocument(
        phaseFormId,
        processId,
        fieldId,
        file,
        (_progress) => {},
      );
      if (!path?.code) {
        setDocsFilled((prev: any) => ({ ...prev, [docId]: { path } }));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingUpload((prev: any) => ({ ...prev, [docId]: false }));
    }
  };

  const calculateStats = () => {
    console.log(faseAtiva, client_product, phaseForms);
    return calculateStatsUtil(
      faseAtiva,
      client_product,
      phaseForms,
      props.selectClient.product,
    );
  };

  const toggleActivity = (id: string, _checked: boolean) => {
    let client_p = { ...client_product };
    if (!client_p.phases) client_p.phases = [];

    if (client_p.phases.includes(id)) {
      client_p.phases = client_p.phases.filter((item: any) => item != id);
    } else {
      client_p.phases.push(id);
    }

    saveClientProduct({
      productId: props.selectClient.product._id,
      client_id: props.selectClient.client._id,
      phases: client_p.phases,
    });
  };

  const handlePrevPhase = () => {
    if (faseAtiva.index > 0) {
      let phase: any = {
        ...props.selectClient.product.phases[faseAtiva.index - 1],
      };
      phase.index = faseAtiva.index - 1;
      setFaseAtiva(phase);
    }
  };

  const handleNextPhase = () => {
    if (faseAtiva.index < props.selectClient.product.phases.length - 1) {
      let phase: any = {
        ...props.selectClient.product.phases[faseAtiva.index + 1],
      };
      phase.index = faseAtiva.index + 1;
      setFaseAtiva(phase);
    }
  };

  const handleSelectPhase = (i: number) => {
    let phase: any = { ...props.selectClient.product.phases[i] };
    phase.index = i;
    setFaseAtiva(phase);
  };

  useEffect(() => {
    setActivity(null);
  }, [faseAtiva]);

  const stats = { ...calculateStats() };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-gray-50 w-[96%] h-[96%] rounded-2xl p-6 relative overflow-hidden flex flex-col">
        {/* Close Button */}
        <button
          onClick={() => props.setSelectClient(null)}
          className="absolute top-4 right-4 text-gray-400 text-2xl z-10 hover:text-gray-600 transition-colors"
        >
          ✕
        </button>

        {/* Tabs - Custom Implementation to match style */}
        <div className="flex justify-center mb-6">
          <div className="bg-white rounded-full p-1 flex shadow-sm border border-gray-100">
            <button
              onClick={() => setSelectedTab("activities")}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
                selectedTab == "activities"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-500 hover:bg-gray-50"
              }`}
            >
              Atividades
            </button>
            <button
              onClick={() => setSelectedTab("forms")}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
                selectedTab == "forms"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-500 hover:bg-gray-50"
              }`}
            >
              Formulários
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex flex-col">
          {selectedTab == "activities" && (
            <>
              <ActivityHeader
                client={{
                  name: props.selectClient?.client?.name || "Cliente",
                  image: props.selectClient?.client?.im,
                  productName: props.selectClient?.product?.name || "Produto",
                }}
                currentPhase={{
                  index: faseAtiva.index || 0,
                  name: faseAtiva.name || "Fase",
                  totalPhases: props.selectClient?.product?.phases?.length || 0,
                }}
                stats={stats}
                phases={props.selectClient?.product?.phases || []}
                onPrevPhase={handlePrevPhase}
                onNextPhase={handleNextPhase}
                onSelectPhase={handleSelectPhase}
              />

              <div className="grid grid-cols-12 gap-6 h-full overflow-hidden pb-4">
                <div className="col-span-5 h-full overflow-hidden">
                  <ActivityList
                    activities={faseAtiva?.activities || []}
                    selectedActivityId={selectActivity?._id}
                    checkedActivities={client_product?.phases || []}
                    loading={loading}
                    stats={stats}
                    onSelectActivity={(item) => setActivity(item)}
                    onToggleActivity={(id, checked) =>
                      toggleActivity(id, checked)
                    }
                  />
                </div>
                <div className="col-span-7 h-full overflow-hidden">
                  {selectActivity ? (
                    <ActivityDetails
                      activity={selectActivity}
                      documents={props.documents}
                      client={props.selectClient?.client}
                      techinicals={techinicals}
                      templates={templates}
                      docsFilled={docsFilled}
                      loadingUploads={loadingUploads}
                      hasBindingQuestion={bindingQuestion}
                      onUploadFile={handleUploadFile}
                      onDownload={(path) => {
                        const link = document.createElement("a");
                        link.href = path;
                        link.target = "_blank";
                        link.click();
                      }}
                    />
                  ) : (
                    <div className="h-full bg-white rounded-2xl shadow-sm flex items-center justify-center text-gray-400 flex-col gap-4">
                      <div className="bg-gray-50 p-6 rounded-full">
                        <span className="text-4xl">📋</span>
                      </div>
                      <p>Selecione uma atividade para ver os detalhes</p>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {selectedTab == "forms" && (
            <div className="h-full overflow-auto">
              <DadosDosFormularios
                products={props.products}
                phaseForms={phaseForms}
                product={props.selectClient.product}
                processes={proccess}
                onReload={loadData}
                loading={loading}
                client={props.selectClient.client}
                documents={props.documents}
                docsFilled={docsFilled}
                loadingUploads={loadingUploads}
                onUploadFile={handleUploadFile}
                onDownload={(path: string) => {
                  const link = document.createElement("a");
                  link.href = path;
                  link.target = "_blank";
                  link.click();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
